import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './modules/layout/layout.module';
import { environment } from 'src/environments/environment';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

// Locales
import es from '@angular/common/locales/es';
registerLocaleData(es);

// Firebase
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { authInterceptorProviders } from "./modules/auth/services/authInterceptor";

// ngx-quill
import { QuillModule } from 'ngx-quill';

// Material
import { RippleGlobalOptions } from '@angular/material/core';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { ErrorService } from './services/error.service';
import { TitleStrategy } from '@angular/router';
import { CustomTitleStrategy } from './helpers/CustomTitleStrategy';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './helpers/TimeoutInterceptor';

const globalRippleConfig: RippleGlobalOptions = {
	animation: {
		enterDuration: 340,
		exitDuration: 100
	}
};
  
@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		LayoutModule,
		HttpClientModule,

		AngularFireModule.initializeApp(environment.firebase),
		AngularFireAuthModule,
		QuillModule.forRoot({
			modules: {
				toolbar: [
					[{ 'size': ['small', false, 'large', 'huge'] }],
					['bold', 'italic', 'underline'],
					[{ 'color': [] }, { 'background': [] }],
					[{ 'list': 'ordered'}, { 'list': 'bullet' }],
					['link', 'blockquote'],
					['clean'],
				],
				keyboard: {
					bindings: {
						tab: {
							key: 9,
							handler: function (range:any, context:any) {
								return true;
							},
						},
					},
				}
			},
		})
	],
	providers: [
		{
			provide: LOCALE_ID,
			useValue: 'es-*'
		},
		{
			provide: MAT_DATE_LOCALE,
			useValue: 'es-ES'
		},
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE]
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: MAT_MOMENT_DATE_FORMATS
		},
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: {appearance: 'outline'}
		},
		{
			provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
			useValue: {formFieldAppearance: "outline"}
		},
		{
			provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
			useValue: {duration: 4500}
		},
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {autoFocus: false}
		},
		authInterceptorProviders,
		{
			provide: MAT_RIPPLE_GLOBAL_OPTIONS,
			useValue: globalRippleConfig
		},
		{
			provide: ErrorHandler,
			useClass: ErrorService
		},
		{
			provide: TitleStrategy,
			useClass: CustomTitleStrategy
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TimeoutInterceptor,
			multi: true
		},
		{
			provide: DEFAULT_TIMEOUT,
			useValue: 12000
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }


